import React from "react";
import Image from "next/image";
import { ADVANTAGE_DATA } from "@/constastants/TailSpendConstants";
import styles from "./TailSpendManagement.module.scss";

function TailSpendAdvantage() {
  return (
    <div className={styles.advantage}>
      <div className={styles.advantageHeader}>
        <h2 className={styles.advantageHeading}>
          The Elchemy Advantage: Tail Spend Analysis Powered by Technology
        </h2>
        <p className={styles.advantageSubtext}>
          Our tech-layered distribution model makes tail spend analysis faster,
          smarter, and more actionable than traditional procurement approaches.
        </p>
      </div>
      <div className={styles.advantageGrid}>
        {ADVANTAGE_DATA.map((item) => (
          <div key={item.id} className={styles.advantageCard}>
            <div className={styles.advantageIcon}>
              <Image
                src={item.icon}
                alt={item.title}
                width={32}
                height={32}
              />
            </div>
            <p className={styles.advantageCardTitle}>{item.title}</p>
            <p className={styles.advantageCardDescription}>
              {item.description}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default TailSpendAdvantage;
